import React from "react";
import "./cardMachine.css";
import io from "socket.io-client";
import { Redirect } from "react-router-dom";
import configUrl from "../../services/configUrl";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClock, faGear, faFileLines } from "@fortawesome/free-solid-svg-icons";
import GraphicsRadius from "../graphicsRadius/GraphicRadius";
import ProductionBar from "./productionBar/productionBar.js";
import socket from "socket.io-client/lib/socket";

let AndonAlert, playPromise;

export default class CardMachine extends React.Component {
  state = {
    oee: this.props.oeeData.oee,
    oeeGoal: this.props.oeeGoal,
    socket: null,
    status: this.props.statusData.status,
    id_machine: this.props.id,
    dispo: this.props.oeeData.disponibility,
    perfo: this.props.oeeData.performance,
    quality: this.props.oeeData.quality,
    produced:this.props.oeeData.produced,
    notify: false,
    statusPrev: null,
    description: this.props.statusData.description,
    stopTime: this.props.statusData.stop_time,
    stop_reason_time:"00:00:00",
    level: this.props.statusData.level,
    verifyBigLength: false,
    statusColor: "#bebebe",
    audio: new Audio(
      `${configUrl.protocol}://${configUrl.ip}/v1/alarm`
    ),
    appointment_date:"",
    isAndon: this.props.statusData.isAndon,
    code: this.props.oeeData.pocode,
    item: this.props.oeeData.item,
    unit: this.props.oeeData.unit,
    alert_message: 0,
    produced_shift: 0,
    quantity_produced_order: 0,
    quantity_requested_order: 0
  };
  

  

  createSocket = () => {
    this.setState({
      socket: io(
        `${configUrl.protocol}://${configUrl.ip}/machine-${this.state.id_machine}`
      ),
    });
  };


  toHHMMSS = (secs) => {
    let sec_num = parseInt(secs, 10)
    let hours   = Math.floor(sec_num / 3600)
    let minutes = Math.floor(sec_num / 60) % 60
    let seconds = sec_num % 60

    return [hours,minutes,seconds]
        .map(v => v < 10 ? "0" + v : v)
        .filter((v,i) => v !== "00" || i > 0)
        .join(":");
}

  getData = (data) => {
    console.log(data);
    let {
      status = this.state.status,
      notify = false,
      description = this.state.description,
      stop_time = this.state.stopTime,
      level = this.state.level,
      alert_message = this.state.alert_message,
      isAndon = this.state.isAndon,
      start_time = this.state.start_time,
      appointment_date = this.state.appointment_date,
      code = this.state.code
    } = data;

    if (alert_message === 1) {
      AndonAlert = setTimeout(() => {
        playPromise = this.state.audio.play();
        if (playPromise !== undefined) {
          playPromise.then(() => {}).catch((err) => {});
        }
      }, 500);
    } else if (alert_message === 0) {
      clearTimeout(AndonAlert);
    }

    switch (status) {
      case null:
        this.setState({ statusColor: "#242424" });
        break;
      case true:
        this.setState({ statusColor: "#05CA83" });
        break;
      case false:
        this.setState({ statusColor: "#e60000" });

        if(status == false && code === "- - -"){
          this.setState({ statusColor: "#ffa31a" });
          description = "Sem ordem de produção"
        }

        break;
      case 2:
        this.setState({ statusColor: "#ffa31a" });
        break;
      case 3:
        this.setState({ statusColor: "#252AC1" });
        break;
      default:
        this.setState({ statusColor: "#05CA83" });
    }
    
    
    let lastRow = new Date(appointment_date + "T" + start_time + "-03:00");
    console.log(appointment_date)
    let diff    = ((Date.now() - lastRow.getTime()) / 1000).toFixed(0);
  
    this.setState({
      status: status,
      notify: notify, 
      //andon stop time
      stopTime: stop_time,
      level: level,
      isAndon: isAndon,
      alert_message: alert_message,
      description:description,
      stop_reason_time:this.toHHMMSS(diff),
    });


    if (this.state.status !== this.state.statusPrev) {
      let notifyObject = { machine: this.props.machine, notify: notify };
      this.props.notifyAction(notifyObject);
    }
    this.setState({ statusPrev: status });
  };

  async componentDidMount() {
    this.getData(this.props.statusData);

    //if (!this.props.onlyStopped) {
        
      await this.createSocket();
      
      this.state.socket.on("reply-namespace", (data) => {
        const { oee, disponibility, performance, quality, piece_code, code,produced, quantity_produced_shift, quantity_produced_order, quantity_requested_order} = data;
        this.setState({
          oee: oee,
          dispo: disponibility,
          perfo: performance,
          quality: quality,
          code: code,
          item: piece_code,
          produced:produced,
          produced_shift: quantity_produced_shift,
          quantity_produced_order: quantity_produced_order,
          quantity_requested_order: quantity_requested_order
        });
      });
      this.state.socket.on("reply-status", (data) => {
        //console.log(data)
        this.getData(data);
      });
    //}
  }

  componentWillUnmount() {
    //if (!this.props.onlyStopped) {
      this.state.socket.removeAllListeners();
      this.setState({ socket: null });
    //}
  }

  componentDidUpdate(prevProps) {
    if (this.props.id !== prevProps.id){
      this.setState({id_machine: this.props.id })
      
    }
    if (this.props.oeeData !== prevProps.oeeData) {
      
      const { oee, disponibility, performance, quality, pocode, item,produced } =
      this.props.oeeData;
      this.setState({
        
        oee: oee,
        dispo: disponibility,
        perfo: performance,
        quality: quality,
        code: pocode,
        item: item,
        produced:produced

      });
    }
    if (this.props.statusData !== prevProps.statusData) {
      this.getData(this.props.statusData);
    }
  }

  render() {
    let {
      oee,
      dispo,
      perfo,
      quality,
      oeeGoal,
      description,
      stopTime,
      level,
      verifyBigLength,
      statusColor,
      isAndon,
      redirect,
      code,
      item,
      produced,unit,
      stop_reason_time,
      status,
      produced_shift,
      quantity_produced_order,
      quantity_requested_order
    } = this.state;

    if (redirect)
      return (
        <Redirect
          to={{
            pathname: `/detalhes`,
            search: "?id_machine=" + this.state.id_machine,
            state: { machine: this.props.machine },
          }}
        />
      );

    return (
      <>
      {socket !== null ? (<div
        id={isAndon ? "andon-alert" : null}
        className="card-container"
        onClick={() => this.setState({ redirect: true })}
        style={{borderTop: `29px solid ${statusColor}`}}
      >
        <div
          className="items-card-container"
          data-tip={verifyBigLength ? null : description}
        >
          <div className="title"> {this.props.machine}</div>
          {/*
          <div className="secondLine">

            <div>
              <span>OEE:{'\n'}</span>
              <span id="oee-value">{oee}%</span>
            </div>
            <div>
              →
            </div>
            <div>
              <span>Meta:{'\n'}</span>
              <span >{oeeGoal}%</span>
            </div>
          </div>
          */}
          <div className="thirdLine">
            <div>
              <span className="lineOrder"><FontAwesomeIcon icon={faFileLines} size="xs"/> </span>
              <span className="cardCode">OP - {code}</span>
            </div>
            |
            <div>
              <span className="lineItem"><FontAwesomeIcon icon={faGear} size="xs"/> </span>
              <span className="cardItem">{item}</span>
            </div>
          </div>
          <div className="lineProduction">
              {/*<span className="cardItem">Produção: {produced > 0 ? produced : "- - -"}{unit === "metroLinear" ? "ML" : ""}</span>*/}
              <ProductionBar value={quantity_produced_order} orderValue={quantity_requested_order}></ProductionBar>
          </div>
          <div className="andon-container" >
            {isAndon ? (
              <div className="reason2">
                Nível:{'\n'}{level}
              </div>
            ) : null}
              <div className="reason2">
                Motivo:{'\n'}{description.length > 23 ? 
              description.slice(0,10)+"..." : description}
              </div>
          </div>
          <div className={!isAndon && status == 0 ? "timeCardMachine" : "timeCardMachine display-none"}>
              <span className="lineItem"><FontAwesomeIcon icon={faClock}/> Tempo:{"\n"}</span>
              <span className="cardItem">{((status == false && code == "- - -") || (stop_reason_time.substring(0,3) == "NaN") ? ("00:00:00") : stop_reason_time)}</span>
          </div>
        
          {isAndon ? (
              <div className="oee-values">
                <p>Tempo Andon:{'\n'}{stopTime}</p>
              </div>
          ) : (
            <div>
            <div className="graphicCard">
              <GraphicsRadius legend="OEE" signal="%" data={oee} backGraphic={oeeGoal}></GraphicsRadius>
              <div className="productionWorkshift">
                <p className="titleProductionWorkshift">Qtd. produzida:</p>
                <p className="productionWorkshiftQt">{produced_shift}</p>
                <p className="titleProductionWorkshift">Turno</p>
              </div>
            </div>
            <div className="oee-values">
              <p>P:{perfo}% </p>
              <p>D:{dispo}% </p>
              <p>Q:{quality}% </p>
            </div>
            </div>
          )}
        </div>
      </div>):("Carregando")}
      </>
      
    );
  }
}